import { render, staticRenderFns } from "./apertura_expediente.vue?vue&type=template&id=f215c9ee&scoped=true"
import script from "./apertura_expediente.vue?vue&type=script&lang=js"
export * from "./apertura_expediente.vue?vue&type=script&lang=js"
import style0 from "./apertura_expediente.vue?vue&type=style&index=0&id=f215c9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f215c9ee",
  null
  
)

export default component.exports